module.exports = __webpack_public_path__ + "img/vernierwhite.c8cc180d.png";